import React, { useState } from 'react';
import { styled } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Colors } from 'library';

interface RPasswordInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
    fullWidth?: boolean;
}

export function RPasswordInput({ value, onChange, placeholder, disabled, fullWidth }: RPasswordInputProps) {
    const [visible, setVisible] = useState(false);

    return (
        <Wrapper fullWidth={fullWidth}>
            <StyledInput
                type={visible ? 'text' : 'password'}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                disabled={disabled}
            />
            <ToggleButton
                type="button"
                onClick={() => setVisible(!visible)}
                tabIndex={-1}
                aria-label={visible ? 'Hide password' : 'Show password'}
            >
                {visible ? (
                    <Visibility style={{ fontSize: 18, color: Colors.mediumGrey }} />
                ) : (
                    <VisibilityOff style={{ fontSize: 18, color: Colors.mediumGrey }} />
                )}
            </ToggleButton>
        </Wrapper>
    );
}

const Wrapper = styled('div')<{ fullWidth?: boolean }>(({ fullWidth }) => ({
    position: 'relative',
    display: 'inline-flex',
    width: fullWidth ? '100%' : 'auto',
}));

const StyledInput = styled('input')({
    width: '100%',
    padding: '10px 40px 10px 14px',
    fontSize: 14,
    color: Colors.darkNavy,
    backgroundColor: Colors.faintGrey,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 10,
    outline: 'none',
    boxSizing: 'border-box',
    '&:focus': {
        borderColor: Colors.mediumGrey,
    },
    '&:disabled': {
        backgroundColor: Colors.lightGrey,
        color: Colors.mediumGrey,
    },
    '&::placeholder': {
        color: Colors.lightGrey,
    },
});

const ToggleButton = styled('button')({
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 2,
    display: 'flex',
    alignItems: 'center',
});
